import React from 'react';
import { Button } from '@mui/material';
import { theme } from 'theme/MainTheme';

const ButtonMUI = ({ onClick, value, type }) => (
  <Button
    type={type}
    variant="contained"
    sx={{ backgroundColor: theme.primary, width: '150px' }}
    onClick={onClick}
  >
    {value}
  </Button>
);
export default ButtonMUI;
